import { makeObservable, observable, action } from 'mobx'
import { IRootStore } from './BaseContrroler';

export default class HomeController {
   private rootStore: IRootStore;
   isNavbarOpen = false
   url = '/'

   constructor(rootStore: IRootStore) {
      makeObservable(this, {
         isNavbarOpen: observable,
         setNavbar: action,
         setUrl: action,
         url: observable,
         ScrollIntoViewHandle: action
      })
      this.rootStore = rootStore
      console.log('homeController')

   }

   setNavbar = (status: boolean) => {
      this.isNavbarOpen = status
   }

   setUrl = (link: any) => {
      this.url = link
   }

   ScrollIntoViewHandle = (selector: any) => {
      const el: any = selector;
      const al = document.getElementById(el)

      console.log(el)
      console.log(al)
      if (al !== null) {
         al.scrollIntoView({ block: 'start', behavior: 'smooth' })
      }
   }

}
